module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/extend.js
// module id = 332
// module chunks = 0 1 2